import styled from 'styled-components';
import Colors from '@/constants/Colors';
import {
  loginSignInButtonClasslinkBackground,
  loginSignInButtonCleverBackground,
  loginSignInButtonGoogleText,
} from '../constants/loginSignInButtonContrast.constants';

export const StyledSignInButton = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
  min-height: 40px;
  border-radius: 50vh;
  color: white;
  box-shadow: 0px 5px 8px -9px #000000;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: white;
    text-shadow: 0px 2px 2px #000;
  }

  &.centered {
    justify-content: center;
    padding-left: 0px;
  }

  .btn-text {
    font-size: 16px;
    padding-right: 8px;
  }

  &.clever {
    background-color: ${loginSignInButtonCleverBackground};
    border: 2px solid ${loginSignInButtonCleverBackground};

    .btn-text {
      color: ${Colors.invertedForeground};
    }
  }
  &.classlink {
    background-color: ${loginSignInButtonClasslinkBackground};
    border: 2px solid ${loginSignInButtonClasslinkBackground};

    .btn-text {
      color: ${Colors.invertedForeground};
    }
  }
  &.google {
    color: ${loginSignInButtonGoogleText};
    background-color: ${Colors.providerBackgrounds.google};
    border: 2px solid ${loginSignInButtonGoogleText};

    .btn-text {
      color: ${loginSignInButtonGoogleText};
    }

    &:hover {
      color: ${Colors.textBlack};
      text-shadow: 0px 2px 2px #ddd;

      .btn-text {
        color: ${Colors.textBlack};
      }
    }
  }
`;
